/**
 * Get two-character initials from a name
 * Takes the first character of the first two words
 * @param name - The name to get initials from
 * @returns Two-character initials (e.g., "John Doe" -> "JD", "Apple" -> "AP")
 */
export const getInitials = (name: string): string => {
  if (!name || typeof name !== 'string') return '?';
  
  const trimmed = name.trim();
  if (!trimmed) return '?';
  
  const words = trimmed.split(/\s+/).filter(word => word.length > 0);
  
  if (words.length === 0) return '?';
  if (words.length === 1) {
    // For single word, take first two characters
    const word = words[0].toUpperCase();
    return word.length >= 2 ? word.substring(0, 2) : word.charAt(0);
  }
  
  // Take first character of first two words
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};
